/* eslint-disable no-param-reassign, no-unused-vars */
import jwtDecode from "jwt-decode";

const mockFetchUser = token =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        const profile = jwtDecode(token);
        resolve(profile);
      } catch (e) {
        reject(e);
      }
    }, 300);
  });

export default {
  state: {
    // WIP
    profile: {
      firstName: "",
      lastName: "",
      sub: "",
      sector: ""
    },
    status: ""
  },

  getters: {
    getProfile: ({ profile }) => profile,
    getProfileIsLoaded: ({ profile }) => !!profile.name
  },

  actions: {
    async fetchUserProfile({ commit }, { token }) {
      try {
        commit("setStatusLoading");
        const userProfile = await mockFetchUser(token);
        commit("setStatusSuccess", { profile: userProfile });
        return true;
      } catch (e) {
        commit("setStatusError");
        return false;
      }
    }
  },

  mutations: {
    setStatusLoading({ status }) {
      status = "loading";
    },

    setStatusSuccess(state, { profile }) {
      state.status = "success";
      state.profile = profile;
    },

    setStatusError({ status }) {
      status = "error";
    }
  },

  namespaced: true
};
